import { Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { isWebView } from 'shared/constants/AppTypeConstants';
import { InstantTransferDescription } from 'shared/modules/superpay/instant-transfer/InstantTransferDescription';
import styled from 'styled-components';

const BoxStyled = styled(Box)`
  flex-direction: column;
  gap: 24px;
`;

export function InstantTransferUnavailable({
  onClose,
}: {
  onClose: () => void;
}) {
  return (
    <BoxStyled
      padding="medium"
      height="100%"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Stack space="medium">
        <Stack space="small">
          <Typography variant="h2">
            Instant Transfer Is Temporarily Unavailable
          </Typography>
          <Typography>
            Thank you for your interest in Instant Transfer! Due to high demand
            and limited beta availability, we’re unable to process any new
            transfers today. More funds will be available soon—check tomorrow to
            try again.
          </Typography>
        </Stack>
        <InstantTransferDescription />
      </Stack>
      <Button fullWidth={isWebView} onClick={onClose}>
        Got It
      </Button>
    </BoxStyled>
  );
}
